/**
 * Utility function to determine if the current pathname represents the homepage.
 *
 * @param pathname - The current pathname from location
 * @param lang - The current language parameter (optional)
 * @returns true if the current path is the homepage, false otherwise
 */
export const isHomepage = (pathname: string, lang?: string): boolean => {
  const detectedLang = lang || extractLanguageFromPathname(pathname);

  return (
    pathname === "/" ||
    pathname === `/${detectedLang}` ||
    pathname === `/${detectedLang}/`
  );
};

/**
 * Extract language code from pathname if present
 * @param pathname - The current pathname
 * @returns language code if found, undefined otherwise
 */
const extractLanguageFromPathname = (pathname: string): string | undefined => {
  const regex = /^\/([a-z]{2})(?=\/|$)/;
  const match = regex.exec(pathname);
  return match ? match[1] : undefined;
};
